/**
 * irie FAQ: category filters + client-side search
 */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.irieFaqInit === '1') return;
    root.dataset.irieFaqInit = '1';

    var searchInput = root.querySelector('[data-irie-faq-search]');
    var filterBtns = root.querySelectorAll('[data-irie-faq-filter]');
    var items = root.querySelectorAll('[data-irie-faq-item]');
    var emptyEl = root.querySelector('[data-irie-faq-empty]');
    var sectionLabel = root.querySelector('[data-irie-faq-active-label]');

    var activeFilter = 'all';
    var searchQuery = '';

    function normalize(str) {
      if (!str) return '';
      return str
        .toLowerCase()
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/İ/g, 'i');
    }

    function getSearchBlob(item) {
      return normalize(item.getAttribute('data-search') || '');
    }

    function matchesSearch(item) {
      if (!searchQuery) return true;
      return getSearchBlob(item).indexOf(searchQuery) !== -1;
    }

    function matchesFilter(item) {
      if (activeFilter === 'all') return true;
      return (item.getAttribute('data-category') || '') === activeFilter;
    }

    function updateSectionLabel() {
      if (!sectionLabel) return;
      var activeBtn = root.querySelector('[data-irie-faq-filter].is-active');
      var label = activeBtn ? activeBtn.getAttribute('data-label') || activeBtn.textContent.trim() : '';
      sectionLabel.textContent = label;
    }

    function apply() {
      var visibleCount = 0;
      items.forEach(function (item) {
        var show = matchesFilter(item) && matchesSearch(item);
        item.classList.toggle('is-hidden', !show);
        if (show) visibleCount++;
        if (!show && item.tagName === 'DETAILS') {
          item.open = false;
        }
      });
      if (emptyEl) {
        emptyEl.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchQuery = normalize(searchInput.value.trim());
        apply();
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeFilter = btn.getAttribute('data-irie-faq-filter') || 'all';
        filterBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        updateSectionLabel();
        apply();
      });
    });

    updateSectionLabel();
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-irie-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-irie-faq]')) {
      e.target.querySelectorAll('[data-irie-faq]').forEach(function (root) {
        delete root.dataset.irieFaqInit;
        initFaq(root);
      });
    }
  });
})();
